// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3vlKh","fileBtn":"File_fileBtn__18iRT","closeBtn":"File_closeBtn__3r_dA","fileSelected":"File_fileSelected__3eJgG","disabled":"File_disabled__nKiLG"};